
export default
{
    code:'BUS_US_SCB_CLIMATE_NEUTRAL',
    currencies: ['USD','EUR','GBP'],
    baskets: {
        includePublicBaskets: false,
        individualCodes: ['SCB_1', 'SCB_2', 'SCB_3', 'SCB_4']
    }
}